import { ApiModel, ApiResource } from 'lib/interfaces/api';

export const USER_NOTIFICATIONS_CASES: CasesCategories[] = [
  'case.assignment',
  'case.creation',
  'case.message_received',
  'case.sla',
  'case.mention',
];
export type CasesCategories =
  | 'case.assignment'
  | 'case.creation'
  | 'case.message_received'
  | 'case.mention'
  | 'case.sla';

export enum UserNotificationStatus {
  Delivered = 'delivered',
  Archived = 'archived',
}

export type UserNotificationsCategories = CasesCategories;

export interface UserNotificationAttributes {
  status: UserNotificationStatus;
  category: UserNotificationsCategories;
  'message-id': string;
  subject: string;
  body: string;
  'delivered-at': string;
  'received-at': string;
  'archived-at': string;
  'canceled-at': string;
  'created-at': string;
  'updated-at': string;
}

export interface UserNotificationRelationships {}

export type UserNotification = ApiResource<
  UserNotificationAttributes,
  UserNotificationRelationships,
  ApiModel.UserNotification
>;
